"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var ListItemButton_1 = __importDefault(require("@mui/material/ListItemButton"));
var ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
var ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
var AppSelectorItem = function (_a) {
    var app = _a.app;
    var locale = (0, react_intl_1.useIntl)().locale;
    return (react_1.default.createElement(Grid_1.default, { key: app.appUrl, item: true, xs: 4 },
        react_1.default.createElement(ListItemButton_1.default, { selected: app.appUrl === window.location.origin, sx: { flexDirection: 'column', borderRadius: 1, px: 1 }, component: "a", href: app.appUrl },
            react_1.default.createElement(ListItemIcon_1.default, { sx: { justifyContent: 'center' } },
                react_1.default.createElement("img", { src: app.iconUrl, width: 40, alt: translate(app.name, locale) })),
            react_1.default.createElement(ListItemText_1.default, { sx: { textAlign: 'center', mb: 0 } }, translate(app.name, locale)))));
};
function translate(text, locale) {
    return typeof text === 'string' ? text : text[locale];
}
exports.default = AppSelectorItem;
